module.exports = __webpack_public_path__ + "static/image-personal-site-0d803e4e1fa21f31407f465a58ceabe0.jpg";